import { __extends } from "tslib";
import { WindowMessenger } from '../WindowMessenger';
import { Logger } from '../Logger/Logger';
import { IframeManager } from '..';
var FrameApi = /** @class */ (function (_super) {
    __extends(FrameApi, _super);
    function FrameApi(options, targetWindow, logger) {
        if (targetWindow === void 0) { targetWindow = window.parent; }
        if (logger === void 0) { logger = new Logger('FrameApi'); }
        var _this = _super.call(this, undefined, logger) || this;
        _this.options = options;
        var WindowManagerCls = _this.constructor.WindowManagerCls;
        var windowManager = new WindowManagerCls(logger);
        _this.setTarget(windowManager.getOpenerWindow());
        return _this;
    }
    FrameApi.setDefaultWindowManager = function (manager) {
        // tslint:disable-next-line:no-static-this
        this.WindowManagerCls = manager;
    };
    FrameApi.prototype.waitForSettings = function (handler) {
        var _this = this;
        this.on(this.options.incomingActions.settings, function (action) {
            handler(action);
            _this.emit(_this.options.outgoingActions.settingsReady());
        });
        this.emit(this.options.outgoingActions.ready());
    };
    FrameApi.WindowManagerCls = IframeManager;
    return FrameApi;
}(WindowMessenger));
export { FrameApi };
//# sourceMappingURL=FrameApi.js.map